export default __webpack_public_path__ + "static/media/CompressedBackgroundEdit.a5a060f6.mp4";